'use strict';

var processInclude = require('base/util');
require('slick-carousel');

$(document).ready(function () {
    processInclude(require('./product/dietDetail'));
    processInclude(require('./components/stepper'));
    processInclude(require('./components/dietCustomize'));
    processInclude(require('./slick/slick'));
});
